<main class="em-l-container main-content">
  <!-- Breadcrumbs -->
  <supplier-breadcrumbs [items]="breadcrumbItems"></supplier-breadcrumbs>

  <div *ngIf="loading">
    <app-loader></app-loader>
  </div>

  <div *ngIf="!loading">
    <div class="em-l em-l--two-column">
      <ul class="em-l__main em-c-definition-list supplier-detail-list">
        <li class="em-c-definition-list__item">
          <div class="em-c-definition-list__key">Supplier Identity:</div>
          <div class="em-c-definition-list__value">
            {{ currentSupplierProfile.supplierIdentity }}
          </div>
        </li>
        <li class="em-c-definition-list__item">
          <div class="em-c-definition-list__key">Supplier Description:</div>
          <div class="em-c-definition-list__value">
            {{ currentSupplierProfile.supplierName }}
          </div>
        </li>
        <li class="em-c-definition-list__item">
          <div class="em-c-definition-list__key">Vendor Code:</div>
          <div class="em-c-definition-list__value">
            {{ currentSupplierProfile.vendCode }}
          </div>
        </li>
        <li class="em-c-definition-list__item">
          <div class="em-c-definition-list__key">Vendor Description:</div>
          <div class="em-c-definition-list__value">
            {{ currentSupplierProfile.vendDescription }}
          </div>
        </li>
        <li class="em-c-definition-list__item">
          <div class="em-c-definition-list__key">Plant Code</div>
          <div class="em-c-definition-list__value">
            {{ currentSupplierProfile.plantCode }}
          </div>
        </li>
        <li class="em-c-definition-list__item">
          <div class="em-c-definition-list__key">Plant Description:</div>
          <div class="em-c-definition-list__value">
            {{ currentSupplierProfile.plantDescription }}
          </div>
        </li>
      </ul>

      <div class="em-l__secondary delete-button">
        <button
          class="em-c-btn"
          (click)="delete(currentSupplierProfile)"
          *ngIf="(storeService.user$ | async)?.canMaintainSupplierProfile"
        >
          <span class="em-c-btn__text">Remove</span>
        </button>
      </div>
    </div>
    <h4>Exceptions</h4>
    <exception-table
      [isViewOnly]="true"
      [exceptions]="currentSupplierProfile.exceptions"
      (saveException)="handleSaveException($event)"
      (cancelException)="handleCancelException($event)"
    ></exception-table>
    <p class="small-text">
      <B>Last changed by :</B> {{ currentSupplierProfile.lastChangedBy }} <br />
      <span>
        <B>Lastest update on :</B>
        {{ currentSupplierProfile.latestUpdated }}
      </span>
    </p>
  </div>
</main>
